<template>
  <div class="app-container" style="padding: 10px">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item label="支付方式" class="custom-item">
          <el-select
            v-model="listQuery.payTypeId"
            :placeholder="$t('company.payType')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item,index) in payLists"
              :key="index"
              :label="item.payTypeName"
              :value="item.payTypeId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="加油时间" class="custom-item">
          <el-date-picker
            v-model="bitTime"
            :default-time="['00:00:00','23:59:59']"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label class="custom-item" style="margin-top:20px">
          <el-button
            v-waves
            v-loading.fullscreen.lock="listLoading"
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >{{ $t('table.search') }}</el-button>
        </el-form-item>
        <el-form-item label class="custom-item" style="margin-top:20px">
          <el-button
            v-waves
            class="filter-item"
            type="info"
            icon="el-icon-document"
            @click="handleFuelToExcel"
          >导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column :label="$t('record.fpNo')" align="center" width="70px">
        <template slot-scope="scope">
          <span>{{ scope.row.fpNo }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.prodName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.prodName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.price')" align="center" width="60px">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="升数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.vol }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.receAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="实收金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.realAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="优惠金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.discAmt }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column :label="$t('record.shiftNo')" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.shiftNo }}</span>
        </template>
      </el-table-column>-->
      <el-table-column label="站点名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.stationName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.payTypeName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.createdTime')" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.pi"
        :page-sizes="[10,20,30]"
        :page-size="listQuery.ps"
        :total="total"
        background
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { fetchFuelHistory } from '@/api/record'
import { listPayType } from '@/api/setting'
import { getDateOfMonth } from '../../utils'
import waves from '@/directive/waves' // 水波纹指令
import { fuelRecordToExcel } from '@/api/download'
import { downloadFile } from '@/utils/file'
export default {
  name: 'HistoryFuel',
  directives: {
    waves
  },
  props: {
    companyId: {
      type: Number,
      required: true
    },
    memberId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: null,
      listLoading: true,
      listQuery: {
        pi: 1,
        ps: 20,
        payTypeId: '',
        beginTime: '',
        endTime: ''
      },
      bitTime: getDateOfMonth(1),
      payLists: []
    }
  },
  watch: {
    $route() {}
  },
  created() {
    listPayType({ status: 1 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          this.payLists.push({
            payTypeId: obj[key].payTypeId,
            payTypeName: obj[key].payTypeName
          })
        }
      }
    })
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      this.listQuery['companyId'] = this.companyId
      this.listQuery['memberId'] = this.memberId
      if (this.bitTime) {
        this.listQuery.beginTime = this.bitTime[0]
        this.listQuery.endTime = this.bitTime[1]
      }
      fetchFuelHistory(this.listQuery).then(response => {
        const row = response.data
        console.log(row)
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pi = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.ps = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pi = val
      this.getList()
    },
    handleFuelToExcel() {
      let loadingIns
      this.$confirm('确定导出加油记录为excel吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        loading: true,
        type: 'info'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          loadingIns = loading
          fuelRecordToExcel(this.listQuery)
            .then(response => {
              if (response.data) {
                const type = response.headers['content-type']
                // response.setHeader("Content-Type", "application/vnd.ms-excel"); type必须和后端的type一致
                downloadFile(response, type)
                loadingIns.close()
              }
            })
            .catch(e => {
              this.$message({
                type: 'warning',
                message: '导出失败！ 原因：' + e
              })
              loadingIns.close()
            })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '取消导出！'
          })
          loadingIns.close()
        })
    }
  }
}
</script>

